import { observer } from 'mobx-react';
import React, { FC, Suspense, useMemo } from 'react';
import { RouteObject, useRoutes } from 'react-router-dom';

import { getPokerRoom } from '../../constants';
import commonStore from '../../store/CommonStore';
import userSettingsStore from '../../store/UserSettingsStore';
import { Loading } from '../Loading/Loading';
import { getRouterConfig } from './router.config';

const Router: FC = () => {
  const routesConfig = useMemo(
    () => getRouterConfig(commonStore.isExpertModeEnabled, getPokerRoom()),
    [commonStore.isExpertModeEnabled],
  );

  const routes = useRoutes(routesConfig as RouteObject[]);

  if (userSettingsStore.isInitUserSettingsLoading) {
    return <Loading />;
  }

  return <Suspense>{routes}</Suspense>;
};

export default observer(Router);
